const STATS = [
    { num: "400M+", lbl: "MSMEs worldwide" },
    { num: "90%", lbl: "operate without a C-suite" },
    { num: "200K+", lbl: "businesses shut down every year" },
    { num: "$0", lbl: "spent on real leadership" },
];

export default function Stats() {
    return (
        <section className="stats" data-testid="v2-stats">
            <div className="container stats__inner">
                <div className="stats__label reveal" data-testid="v2-stats-label">
                    The reality for MSMEs around the globe
                </div>
                <div className="stats__grid">
                    {STATS.map((s, i) => (
                        <div
                            className="stat reveal"
                            key={s.lbl}
                            data-testid={`v2-stat-${i}`}
                        >
                            <div className="stat__num">{s.num}</div>
                            <div className="stat__lbl">{s.lbl}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
